import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState,
} from 'react';

interface ReleaseNotesProviderProps {
  children: ReactNode;
}

interface ReleaseNotesContextType {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const ReleaseNotesContext = createContext<ReleaseNotesContextType | null>(null);

export const ReleaseNotesProvider = ({
  children,
}: ReleaseNotesProviderProps) => {
  const [open, setOpen] = useState(false);

  return (
    <ReleaseNotesContext.Provider value={{ open, setOpen }}>
      {children}
    </ReleaseNotesContext.Provider>
  );
};

export const useReleaseNotesContext = () => {
  const context = useContext(ReleaseNotesContext);
  if (!context) {
    throw new Error(
      'useReleaseNotesContext must be used within a ReleaseNotesContextProvider',
    );
  }
  return context;
};
